import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import * as dateutil from "@appbase/util/date-helper";

export interface AttendanceManageFilterModel {
    targetDate: Date;
    selectedWorkPart: string;
    selectedTask: string;
}

@Component({

})
export default class AttendanceManageFilter extends Vue {
    @Prop({ type: Array }) weekList!: Date[];
    @Prop({ type: String }) selectedWorkPart!: string;
    @Prop({ type: String }) selectedTask!: string;

    workPartList: any = [
        {
            text: '오전',
            value: 'morning'
        }
    ];
    taskList: any = [
        {
            text: '점장',
            value: 'manager'
        }
    ];

    targetDate: Date = new Date();
    currentWorkPart: string = '';
    currentTask: string = '';

    get weekStartDate() {
        return dateutil.uGetDateFormat('yyyy년 MM월 DD일', this.weekList[0]);
    }

    get weekEndDate() {
        return dateutil.uGetDateFormat('yyyy년 MM월 DD일', this.weekList[this.weekList.length - 1]);
    }

    onThisWeekClick() {
        this.targetDate = new Date();
        this.emitFilter();
    }

    onPrevWeekClick() {
        this.targetDate = this.weekList[0];
        this.targetDate.setDate(this.targetDate.getDate() - 7);
        this.emitFilter();
    }

    onNextWeekClick() {
        this.targetDate = this.weekList[0];
        this.targetDate.setDate(this.targetDate.getDate() + 7);
        this.emitFilter();
    }

    emitFilter() {
        let filterModel: AttendanceManageFilterModel = {
            targetDate: this.targetDate,
            selectedWorkPart: this.currentWorkPart,
            selectedTask: this.currentTask
        }
        this.$emit('emitFilter', filterModel);
    }

    created() {
        this.targetDate = new Date();
        this.currentWorkPart = this.selectedWorkPart;
        this.currentTask = this.selectedTask;
        this.emitFilter();
    }
}